import { Button } from 'reactstrap';

export const BaseCustomButton = ({
  color = 'primary',
  outline = false,
  rounded = true,
  fullWidth = false,
  className = '',
  icon = '',
  isLoading = false,
  label = '',
  children, // Keeps support for direct children usage
  ...props
}) => {
  return (
    <Button
      color={color}
      outline={outline}
      disabled={isLoading} // Disable button when loading
      className={`${rounded ? 'rounded-3' : ''} ${fullWidth ? 'w-100' : ''} ${className}`}
      {...props}
    >
      {isLoading ? (
        <span className="mdi mdi-loading mdi-spin me-2"></span> // Show loading icon
      ) : (
        icon && <span className={`mdi ${icon} me-2`}></span>
      )}
      {label || children} {/* Uses label prop first, falls back to children */}
    </Button>
  );
};